module.exports = __webpack_public_path__ + "static/lakeland-steam-logo-black-03fdfa5d1a497d7ef3142fdc8b2a1f23.png";